<script setup lang="ts">
import { BoxesIcon } from 'lucide-vue-next'

const { data: recyclerWelcomeScreenPendingResponse, isPending } = useRecyclerWelcomeScreenPendingResponse()

const { t } = useI18n()
const router = useRouter()
</script>

<template>
  <div v-if="isPending">
    <div class="skeleton h-32 w-full" />
  </div>
  <div v-else-if="recyclerWelcomeScreenPendingResponse?.count" class="bg-primary p-8 rounded-xl flex gap-2 items-center text-primary-content">
    <BoxesIcon :size="24" />
    <span class="text-lg font-bold">
      {{ t('global.recycler_welcome_screen_pending_response_card_title', { count: recyclerWelcomeScreenPendingResponse?.count }) }}
    </span>

    <EButton class="ml-auto btn-secondary" @click="router.push('/my-materials')">
      {{ t('global.see_all') }}
    </EButton>
  </div>
</template>
